const EXACT_AGENT_DIRECTORY_ROUTES = new Set([
  "/",
  "/agents",
  "/agents/a-z",
  "/vendors",
  "/nar-designations",
  "/admin",
  "/account/profile",
  "/account/interactions",
]);

function stripTenantPrefix(pathname: string, tenantPathPrefix?: string): string {
  if (!tenantPathPrefix) return pathname;
  const prefix = `/${tenantPathPrefix}`;
  if (pathname === prefix) return "/";
  return pathname.startsWith(`${prefix}/`) ? pathname.slice(prefix.length) : pathname;
}

/** Return only approved templates. Unknown paths collapse to `/other`. */
export function agentDirectoryRouteTemplate(
  pathname: string,
  tenantPathPrefix?: string,
): string {
  const path = stripTenantPrefix(pathname, tenantPathPrefix).replace(/\/+$/, "") || "/";
  if (EXACT_AGENT_DIRECTORY_ROUTES.has(path)) return path;
  if (/^\/agents\/county\/[^/]+$/.test(path)) return "/agents/county/[hubSlug]";
  if (/^\/agents\/city\/[^/]+$/.test(path)) return "/agents/city/[hubSlug]";
  if (/^\/agents\/language\/[^/]+$/.test(path)) return "/agents/language/[hubSlug]";
  if (/^\/agents\/[^/]+$/.test(path)) return "/agents/[slug]";
  if (/^\/vendors\/category\/[^/]+$/.test(path)) return "/vendors/category/[hubSlug]";
  if (/^\/vendors\/[^/]+$/.test(path)) return "/vendors/[slug]";
  if (/^\/properties\/[^/]+$/.test(path)) return "/properties/[key]";
  if (/^\/admin\/agents\/[^/]+$/.test(path)) return "/admin/agents/[agentId]";
  if (/^\/admin\/[^/]+(?:\/[^/]+)?$/.test(path)) return "/admin/[section]";
  if (/^\/account\/[^/]+$/.test(path)) return "/account/[section]";
  return "/other";
}
